"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribeToMarginPositionEvents = exports.requestOpenPositions = exports.requestClosedPositions = exports.repayMarginPosition = exports.receiveRepaymentAssetOptions = exports.receiveOpenPositions = exports.receiveClosedPositions = exports.getRepaymentAssetOptions = exports.getOpenPositions = exports.getClosedPositions = exports.closeMarginPosition = exports.cancelMarginPosition = exports.GetEstimatedAmountForClosePositionBySettlement = void 0;
var _apiActions = require("../../actions/apiActions");
var _snackbarActions = require("../../actions/snackbarActions");
var _MarginPositionSubscriptionService = _interopRequireDefault(require("../services/MarginPositionSubscriptionService"));
var _selectors = require("../selectors");
var _marginActions = require("./marginActions");
var _actionTypes = require("../actionTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var getOpenPositions = exports.getOpenPositions = function getOpenPositions(AccountId, OMSId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch) {
      var positions, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            dispatch(requestOpenPositions());
            _context.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetMarginPositions', {
              omsId: OMSId,
              accountId: AccountId
            }));
          case 1:
            positions = _context.v;
            if (Array.isArray(positions)) {
              dispatch(receiveOpenPositions(positions));
            } else {
              console.error('GetMarginPositionStates error: ', positions.errormsg);
            }
            _context.n = 3;
            break;
          case 2:
            _context.p = 2;
            _t = _context.v;
            console.error('GetMarginPositionStates error: ', _t);
          case 3:
            return _context.a(2);
        }
      }, _callee, null, [[0, 2]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var getClosedPositions = exports.getClosedPositions = function getClosedPositions(AccountId, OMSId) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch) {
      var positions, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _context2.p = 0;
            dispatch(requestClosedPositions());
            _context2.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetMarginPositionHistory', {
              omsId: OMSId,
              accountId: AccountId
            }));
          case 1:
            positions = _context2.v;
            if (Array.isArray(positions)) {
              dispatch(receiveClosedPositions(positions));
            } else {
              console.error('GetMarginPositionHistory error: ', positions.errormsg);
            }
            _context2.n = 3;
            break;
          case 2:
            _context2.p = 2;
            _t2 = _context2.v;
            console.error('GetMarginPositionHistory error: ', _t2);
          case 3:
            return _context2.a(2);
        }
      }, _callee2, null, [[0, 2]]);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var subscribeToMarginPositionEvents = exports.subscribeToMarginPositionEvents = function subscribeToMarginPositionEvents(AccountId) {
  return function (dispatch) {
    _MarginPositionSubscriptionService["default"].subscribe(function (position) {
      if (!position) return;
      if (position.PositionState === 'Open' && position.ChangeReason === 'UnableToClose') {
        var _position$RemainingLi;
        var hasLiability = Number((_position$RemainingLi = position.RemainingLiability) !== null && _position$RemainingLi !== void 0 ? _position$RemainingLi : 0) > 0;
        var symbol = "".concat(position.BaseProductSymbol || '').concat(position.QuoteProductSymbol || '');
        if (hasLiability) {
          dispatch((0, _snackbarActions.showSnack)({
            id: 'unableToClosePositionErrorSnack',
            text: "Position ".concat(symbol, " could not be closed. There is still an outstanding liability, please verify and try again."),
            type: 'warning'
          }));
        } else {
          dispatch((0, _snackbarActions.showSnack)({
            id: 'unableToClosePositionNoLiabilitySnack',
            text: "Position ".concat(symbol, " could not be closed. The loan has been fully repaid. You can cancel this position to close it without further trading."),
            type: 'warning'
          }));
        }
      }
      if (position.PositionState === 'Closed' && (position.ChangeReason === 'CloseOperation' || position.ChangeReason === 'SoldToClose' || position.ChangeReason === 'BoughtToClose')) {
        dispatch((0, _snackbarActions.showSnack)({
          id: 'closePositionSuccessSnack',
          text: "Position ".concat(position.BaseProductSymbol).concat(position.QuoteProductSymbol, " closed"),
          type: 'success'
        }));
      }
      if (position.ChangeReason === 'UnableToRepay') {
        dispatch((0, _snackbarActions.showSnack)({
          id: 'unableToFullyRepayPositionErrorSnack',
          text: 'There was a problem trying to repay the specified amount with the selected assets. Please try again.',
          type: 'warning'
        }));
      }
      if (position.ChangeReason === 'Repaid') {
        dispatch((0, _snackbarActions.showSnack)({
          id: 'repayPositionSuccessSnack',
          text: "Your ".concat(position.BaseProductSymbol).concat(position.QuoteProductSymbol, " ").concat(position.PositionType, " position has been repaid successfully."),
          type: 'success'
        }));
      }
      if (position.AccountId === AccountId) {
        dispatch({
          type: _actionTypes.UPDATE_POSITION,
          payload: position
        });
        dispatch((0, _marginActions.getMaxTransferAmount)(position.BaseProductId));
        dispatch((0, _marginActions.getMaxTransferAmount)(position.QuoteProductId));
      }
    });
  };
};
var requestOpenPositions = exports.requestOpenPositions = function requestOpenPositions() {
  return {
    type: _actionTypes.REQUEST_OPEN_POSITIONS
  };
};
var requestClosedPositions = exports.requestClosedPositions = function requestClosedPositions() {
  return {
    type: _actionTypes.REQUEST_CLOSED_POSITIONS
  };
};
var receiveOpenPositions = exports.receiveOpenPositions = function receiveOpenPositions(payload) {
  return {
    type: _actionTypes.RECEIVE_OPEN_POSITIONS,
    payload: payload
  };
};
var receiveClosedPositions = exports.receiveClosedPositions = function receiveClosedPositions(payload) {
  return {
    type: _actionTypes.RECEIVE_CLOSED_POSITIONS,
    payload: payload
  };
};
var closeMarginPosition = exports.closeMarginPosition = function closeMarginPosition(_ref3, RepaymentAssets) {
  var AccountId = _ref3.AccountId,
    PositionId = _ref3.PositionId,
    PositionInstrumentId = _ref3.PositionInstrumentId;
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dispatch) {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            _context3.n = 1;
            return dispatch((0, _apiActions.callAPI)('CloseMarginPosition', {
              AccountId: AccountId,
              PositionId: PositionId,
              PositionInstrumentId: PositionInstrumentId,
              RepaymentAssets: RepaymentAssets
            })).then(function (res) {
              if (res.status !== 'Accepted') {
                dispatch((0, _snackbarActions.showSnack)({
                  id: 'closeOpenPositionsErrorSnack',
                  text: "".concat(res.errormsg),
                  type: 'warning'
                }));
              }
            })["catch"](function (_error) {
              dispatch((0, _snackbarActions.showSnack)({
                id: 'closeOpenPositionsErrorSnack',
                text: 'An error occurred while closing the position. Please try again.',
                type: 'warning'
              }));
            });
          case 1:
            return _context3.a(2, _context3.v);
        }
      }, _callee3);
    }));
    return function (_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var cancelMarginPosition = exports.cancelMarginPosition = function cancelMarginPosition(_ref5) {
  var AccountId = _ref5.AccountId,
    PositionId = _ref5.PositionId,
    PositionInstrumentId = _ref5.PositionInstrumentId,
    PositionType = _ref5.PositionType,
    instrument = _ref5.instrument;
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(dispatch) {
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            _context4.n = 1;
            return dispatch((0, _apiActions.callAPI)('CancelMarginPosition', {
              AccountId: AccountId,
              PositionId: PositionId,
              PositionInstrumentId: PositionInstrumentId
            })).then(function (res) {
              if (res.status === 'Accepted') {
                dispatch((0, _snackbarActions.showSnack)({
                  id: 'cancelOpenPositionsSuccessSnack',
                  text: "Your ".concat(PositionType, " ").concat(instrument.Symbol, " position has been cancelled succesfully."),
                  type: 'success'
                }));
              } else {
                dispatch((0, _snackbarActions.showSnack)({
                  id: 'cancelOpenPositionsErrorSnack',
                  text: "There was an error cancelling your ".concat(PositionType, " ").concat(instrument.Symbol, " position. Error Details: ").concat(res.errormsg),
                  type: 'warning'
                }));
              }
            })["catch"](function (_error) {
              dispatch((0, _snackbarActions.showSnack)({
                id: 'cancelOpenPositionsErrorSnack',
                text: 'An error occurred while cancelling the position. Please try again.',
                type: 'warning'
              }));
            });
          case 1:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return function (_x4) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var GetEstimatedAmountForClosePositionBySettlement = exports.GetEstimatedAmountForClosePositionBySettlement = function GetEstimatedAmountForClosePositionBySettlement(OrderId, InstrumentId) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(dispatch, getState) {
      var OMSId, _marginAccountSelecto, AccountId;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            OMSId = getState().user.userInfo.OMSId;
            _marginAccountSelecto = (0, _selectors.marginAccountSelector)(getState()), AccountId = _marginAccountSelecto.AccountId;
            _context5.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetEstimatedAmountForClosePositionBySettlement', {
              OMSId: OMSId,
              AccountId: AccountId,
              OrderId: OrderId,
              InstrumentId: InstrumentId
            }));
          case 1:
            return _context5.a(2, _context5.v);
        }
      }, _callee5);
    }));
    return function (_x5, _x6) {
      return _ref7.apply(this, arguments);
    };
  }();
};
var receiveRepaymentAssetOptions = exports.receiveRepaymentAssetOptions = function receiveRepaymentAssetOptions(payload) {
  return {
    type: _actionTypes.RECEIVE_REPAYMENT_ASSET_OPTIONS,
    payload: payload
  };
};
var getRepaymentAssetOptions = exports.getRepaymentAssetOptions = function getRepaymentAssetOptions(PositionId) {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(dispatch, getState) {
      var OMSId, _marginAccountSelecto2, AccountId, repaymentAssetOptions, _t3;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            _context6.p = 0;
            OMSId = getState().user.userInfo.OMSId;
            _marginAccountSelecto2 = (0, _selectors.marginAccountSelector)(getState()), AccountId = _marginAccountSelecto2.AccountId;
            _context6.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetRepaymentAssetOptions', {
              OMSId: OMSId,
              AccountId: AccountId,
              PositionId: PositionId
            }));
          case 1:
            repaymentAssetOptions = _context6.v;
            if (Array.isArray(repaymentAssetOptions)) {
              dispatch(receiveRepaymentAssetOptions(repaymentAssetOptions));
            }
            _context6.n = 3;
            break;
          case 2:
            _context6.p = 2;
            _t3 = _context6.v;
            console.error('GetRepaymentAssetOptions error: ', _t3);
          case 3:
            return _context6.a(2);
        }
      }, _callee6, null, [[0, 2]]);
    }));
    return function (_x7, _x8) {
      return _ref8.apply(this, arguments);
    };
  }();
};
var repayMarginPosition = exports.repayMarginPosition = function repayMarginPosition(_ref9) {
  var AccountId = _ref9.AccountId,
    PositionId = _ref9.PositionId,
    PositionInstrumentId = _ref9.PositionInstrumentId,
    PercentageToRepay = _ref9.PercentageToRepay,
    RepaymentAssets = _ref9.RepaymentAssets,
    Instrument = _ref9.Instrument,
    PositionType = _ref9.PositionType;
  return /*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(dispatch) {
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.n) {
          case 0:
            _context7.n = 1;
            return dispatch((0, _apiActions.callAPI)('RepayMarginPosition', {
              AccountId: AccountId,
              PositionId: PositionId,
              PositionInstrumentId: PositionInstrumentId,
              PercentageToRepay: PercentageToRepay,
              RepaymentAssets: RepaymentAssets
            })).then(function (res) {
              if (res.status !== 'Accepted') {
                dispatch((0, _snackbarActions.showSnack)({
                  id: 'repayPositionErrorSnack',
                  text: "There was an error repaying your ".concat(PositionType, " ").concat(Instrument.Symbol, " position. Error Details: ").concat(res.errormsg),
                  type: 'warning'
                }));
              }
            })["catch"](function (_error) {
              dispatch((0, _snackbarActions.showSnack)({
                id: 'repayPositionErrorSnack',
                text: 'An error occurred while repaying the position. Please try again.',
                type: 'warning'
              }));
            });
          case 1:
            return _context7.a(2);
        }
      }, _callee7);
    }));
    return function (_x9) {
      return _ref0.apply(this, arguments);
    };
  }();
};